export const INTERFACE_CHANGED = "INTERFACE_CHANGED";

export const shouldClearSnapshotId = event => event === INTERFACE_CHANGED;
